function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "11",
  viewBox: "0 0 12 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.289 4.78a1.441 1.441 0 00-1.123-1.151L8.2 3.214l-.524-1.94A1.445 1.445 0 006.466.217a1.441 1.441 0 00-1.44.713l-1 1.744-2.01-.102a1.484 1.484 0 00-1.393.835 1.437 1.437 0 00.236 1.589l1.35 1.491-.711 1.883a1.429 1.429 0 00.355 1.564 1.438 1.438 0 001.582.27l1.834-.824 1.566 1.261a1.444 1.444 0 001.603.139c.514-.279.808-.842.746-1.425L8.97 7.358l1.684-1.099c.491-.322.74-.903.63-1.481l.005.002z",
  fill: "#fff"
})));